var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "wd-icon-arrow-left wd-icon",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    className: "wd-icon-container",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "wd-icon-fill",
    d: "M13.436 5.263a.506.506 0 00-.003-.71l-.7-.701a.495.495 0 00-.71-.003l-7.779 7.777a.5.5 0 00-.144.352.48.48 0 00.144.356l7.778 7.778a.506.506 0 00.71-.003l.701-.7a.495.495 0 00.003-.711l-5.702-5.703H19.36c.273 0 .5-.226.5-.505v-.99a.495.495 0 00-.5-.505H7.704z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.18cb1c2ec842fcf8d2e66d624fdde7bc.svg";
export { ForwardRef as ReactComponent };